'use client';

import { useEffect, useState } from 'react';
import { Requester } from '@/lib/Requester';
import { Endpoints } from '@/lib/Endpoints';
import { UserPromoCode } from '@/models/Order';
import { formatDate } from '@/lib/utils';
import { toast } from './ui/use-toast';
import { Spinner } from './ui/spinner';

export default function ProfileTabAccountInfoCodes({
  onCodeClick,
}: {
  onCodeClick?: (code: string) => void;
}) {
  const [codes, setCodes] = useState<UserPromoCode[] | null>(null);

  useEffect(() => {
    getUserCodes();
  }, []);

  const getUserCodes = async () => {
    const { data } = await Requester.get(Endpoints.GET_PROMO_CODES);
    setCodes(data?.data?.codes || []);
  };

  const copyToClipboard = (code: string) => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        toast({
          variant: 'default',
          description: 'Kod kopyalandı!',
        });
      })
      .catch((err) => {
        toast({
          variant: 'destructive',
          description: 'Kod kopyalanamadı!',
        });
      });
  };

  if (!codes) {
    return onCodeClick ? <Spinner className="mx-auto size-8 text-[#AF0E1D]" /> : <></>;
  }

  if (codes.length === 0) {
    return (
      <div className="text-center py-10">
        <div className="text-2xl">Henüz indirim kodunuz yok</div>
        <div className="text-sm text-gray-500">
          Siparişlerinizde kullanabileceğiniz indirim kodları burada görünecektir.
        </div>
      </div>
    );
  }

  return (
    <div className="referralPageLog" style={{ marginBottom: '24px' }}>
      <div className="referralPageLogTitle">İndirim Kodları</div>
      <div className="referralPageLogList sm:block hidden">
        <div className="referralPageLogHeader">
          <div className="referralPageLogCol">Kampanya</div>
          <div className="referralPageLogCol">İndirim Kodu</div>
          <div className="referralPageLogCol">İndirim</div>
          <div className="referralPageLogCol">Geçerlilik</div>
          {onCodeClick && <div className="referralPageLogCol"></div>}
        </div>
        {codes.map((log, index) => (
          <div key={`log ${index}`} className="referralPageLogItem">
            <div className="referralPageLogCol">{log.title}</div>
            <div className="referralPageLogCol" onClick={() => copyToClipboard(log.code)}>
              {log.code}
            </div>
            <div className="referralPageLogCol">{log.amount}</div>
            <div className="referralPageLogCol">{formatDate(new Date(log.endTime))}</div>
            {onCodeClick && (
              <div
                className="referralPageLogCol text-hzc_purple_500 underline cursor-pointer"
                onClick={() => onCodeClick(log.code)}
              >
                Seç
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-2 justify-center w-full sm:hidden">
        {codes.map((log, index) => (
          <div
            key={`log ${index}`}
            className="bg-hzc_beige_200 flex flex-row gap-4 px-4 py-2 rounded-[24px] items-center"
            onClick={() => (onCodeClick ? onCodeClick(log.code) : copyToClipboard(log.code))}
          >
            <div className="p-2 bg-hzc_purple_500 text-white rounded-lg w-20 text-center">
              {log.amount}
            </div>
            <div className="flex flex-col flex-1">
              <div className="text-m">{log.title}</div>
              <div className="text-sm">Kod: {log.code}</div>
              <div className="text-sm">Son Tarih: {formatDate(new Date(log.endTime))}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="referralPageLogNote">
        - İndirim kodları sadece üyelere özeldir.
        <br />
        - Her bir indirim kodundan yalnızca bir kez yararlanabilir.
        <br />- İndirim kodları birleştirilemez.
      </div>
      <div className="referralPageLogWarning">
        - Hızlı Çiçek indirim kodu ve hediye çeki koşullarında istediği zaman değişiklik yapma
        hakkına sahiptir.
      </div>
    </div>
  );
}
